import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router";
import { PageTabs } from "@/components/ui/page-tabs";
import { useGetTag } from "@/queries/tags/tags.api";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Heading,
  Icon,
} from "@elaniintc/goes-design-system";
import { TagDetail } from "./components/TagDetail";
import { TagHistory } from "./components/TagHistory";
import NewTagModal from "../components/NewTagModal";

export const TagDetailsPage = () => {
  const [activeTab, setActiveTab] = useState<"detalles" | "historial">(
    "detalles",
  );
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const navigate = useNavigate();

  const { data: tagData, refetch: refetchTag } = useGetTag(id);

  console.log("Tag ID from params:", id);
  console.log("Tag data:", tagData);

  const tag = tagData?.data;

  const [modalState, setModalState] = useState<"idle" | "edit">("idle");

  useEffect(() => {
    if (type === "historial") {
      setActiveTab("historial");
      const params = new URLSearchParams(searchParams);
      params.delete("type");
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [type, searchParams, navigate]);

  const handleEditTag = () => {
    setModalState("edit");
  };

  const handleCloseEditModal = () => {
    setModalState("idle");
  };

  const handleEditSuccess = () => {
    refetchTag();
    setModalState("idle");
  };

  if (!tag) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <p>Etiqueta no encontrada</p>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex flex-col">
      {/* Tabs */}
      <div className="flex w-full justify-between items-center border-b border-neutral">
        <Heading variant="h6">{tag.name}</Heading>
        <div className="flex gap-2 items-center">
          <PageTabs
            tabs={[
              { label: "Detalles", key: "detalles" },
              { label: "Historial", key: "historial" },
            ]}
            activeKey={activeTab}
            onTabChange={(key) => setActiveTab(key as "detalles" | "historial")}
            className="border-b-0 !pb-0"
          />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="tertiary"
                size="icon"
                aria-label="Opciones"
                type="button"
              >
                <Icon name="ellipsis-vertical" type="far" className="text-sm" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-[222px] min-w-56 rounded-lg border-neutral-silent text-body font-normal p-2 shadow-neutral-xl"
              side="left"
              align="start"
              sideOffset={4}
            >
              <DropdownMenuGroup>
                <DropdownMenuItem
                  className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                  asChild
                >
                  <button
                    type="button"
                    className="w-full"
                    onClick={handleEditTag}
                  >
                    Editar etiqueta
                  </button>
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>

      {modalState === "edit" && (
        <NewTagModal
          open={modalState === "edit"}
          onClose={handleCloseEditModal}
          onSuccess={handleEditSuccess}
          editData={tag}
        />
      )}

      {/* Contenido dinámico */}
      {activeTab === "detalles" ? (
        <TagDetail tag={tag} />
      ) : (
        <TagHistory tagId={id} />
      )}
    </div>
  );
};
